import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2, toPropertyKey as _toPropertyKey } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import FormContext$1 from './FormContext.js';
import { getFormComponentOptions } from './config.js';
import { FormChangeSource } from './constants.js';
import { fieldFormState, isValueSet } from './utils.js';

var _excluded = ["field", "initialData", "autoHide", "disabled", "as"];
/**
 * A button to clear or reset form fields when clicked
 */

var FieldClearer = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldClearer, _React$Component);

  var _super = _createSuper(FieldClearer);

  function FieldClearer() {
    var _this;

    _classCallCheck(this, FieldClearer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getFieldsToClear", function () {
      var _this$context$value = _this.context.value,
          value = _this$context$value === void 0 ? {} : _this$context$value;
      var field = _this.props.field;
      if (!field) return Object.keys(value);
      return Array.isArray(field) ? field : [field];
    });

    _defineProperty(_assertThisInitialized(_this), "canClear", function () {
      var _this$context$value2 = _this.context.value,
          value = _this$context$value2 === void 0 ? {} : _this$context$value2;

      var fields = _this.getFieldsToClear();

      var initialData = _this.props.initialData;
      var resetData = typeof initialData === "function" ? initialData(fieldFormState(_this.context)) : initialData !== null && initialData !== void 0 ? initialData : {};
      return fields.some(function (f) {
        var initialValue = resetData[f];
        return initialValue !== undefined ? value[f] !== initialValue : isValueSet(value[f]);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var onChange = _this.context.onChange;

      var fields = _this.getFieldsToClear();

      var initialData = _this.props.initialData;
      var resetData = typeof initialData === "function" ? initialData(fieldFormState(_this.context)) : initialData !== null && initialData !== void 0 ? initialData : {};

      var applyChanges = function applyChanges(prevValue) {
        return fields.reduce(function (acc, f) {
          var initialValue = resetData[f];

          if (initialValue !== undefined) {
            // set to the specified initial value
            return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, f, initialValue));
          } // remove the field from the form data


          acc[f];

          var nextAcc = _objectWithoutProperties(acc, [f].map(_toPropertyKey));

          return nextAcc;
        }, prevValue);
      };

      var metadata = {
        source: FormChangeSource.Clearer
      };

      if (onChange) {
        onChange(fields.length === 1 ? fields[0] : fields, undefined, applyChanges, metadata);
      }
    });

    return _this;
  }

  _createClass(FieldClearer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.as && !getFormComponentOptions().defaultFieldClearerAs) {
        console.warn("FieldClearer 'as' prop has not been set and has no default configuration");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
      _this$props.field;
      _this$props.initialData;

      var autoHide = _this$props.autoHide,
          disabled = _this$props.disabled,
          as = _this$props.as,
          otherProps = _objectWithoutProperties(_this$props, _excluded);

      var canClear = this.canClear();
      if (autoHide && !canClear) return null;
      var Component = as || getFormComponentOptions().defaultFieldClearerAs;
      if (!Component) return null;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClear,
        disabled: disabled || !canClear
      }));
    }
  }]);

  return FieldClearer;
}(React.Component);

_defineProperty(FieldClearer, "propTypes", {
  field: _pt.oneOfType([_pt.string, _pt.arrayOf(_pt.string)]),
  initialData: _pt.oneOfType([_pt.any, _pt.func]),
  autoHide: _pt.bool,
  disabled: _pt.bool,
  as: _pt.elementType
});

_defineProperty(FieldClearer, "defaultProps", {
  autoHide: true
});

_defineProperty(FieldClearer, "contextType", FormContext$1);

var FieldClearer$1 = FieldClearer;

export { FieldClearer$1 as default };
